import { METRICS } from '@/lib/constants/metrics'

export type Stat = {
  value: number
  suffix: string
  label: { en: string; fa: string }
}

export const heroStats: Stat[] = [
  {
    value: METRICS.totalCreators.value,
    suffix: '+',
    label: { en: 'Influencers', fa: 'اینفلوئنسر' },
  },
  { value: 44, suffix: 'M+', label: { en: 'Active Rubika Users', fa: 'کاربر فعال روبیکا' } },
  { value: 31, suffix: '', label: { en: 'Provinces Covered', fa: 'استان تحت پوشش' } },
  {
    value: 15,
    suffix: 'M',
    label: { en: 'Daily Digital Impressions', fa: 'ایمپرشن دیجیتال روزانه' },
  },
]

export const trackStats: Stat[] = [
  { value: 1100, suffix: '+', label: { en: 'Media Spots', fa: 'اسپات رسانه‌ای' } },
  { value: 70, suffix: 'M+', label: { en: 'Spot Views', fa: 'بازدید اسپات' } },
  { value: 7100, suffix: '+', label: { en: 'Campaigns', fa: 'کمپین' } },
  { value: 90, suffix: '%+', label: { en: 'Client Satisfaction', fa: 'رضایت مشتری' } },
]
